<template>
  <div>
    <!-- 无需维护商品 -->
    <div class="search">
      <!-- 客户ID -->
      <div class="item">
        <el-input clearable v-model="datas.user_id" :placeholder="$t('message.userID')"
          @blur="setDefaultValue"></el-input>
      </div>
      <!-- 店铺ID -->
      <div class="item">
        <el-input clearable v-model="datas.shop_id" :placeholder="$t('message.shopID')"></el-input>
      </div>
      <!-- 店铺名 -->
      <div class="item">
        <el-input clearable v-model="datas.shop_name" :placeholder="$t('message.shopName')"></el-input>
      </div>
      <!-- 商品ID -->
      <div class="item">
        <el-input clearable v-model="datas.goods_id" :placeholder="$t('message.goodsID')"></el-input>
      </div>
      <!-- 搜索 -->
      <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
      <!-- 重置 -->
      <el-button @click="reset">{{ $t('message.reset') }}</el-button>
      <!--  -->
    </div>
    <!-- 操作 -->
    <div class="operation">
      <div class="check">
        <div class="item" style="margin-right: 24px;">
          <!-- 选择同店铺商品 -->
          <el-checkbox v-model="checked1" @change="allSame('shop_name', 'checked1')">{{
            $t('message.selectProductsFromTheSameStore') }}</el-checkbox>
        </div>
        <div class="item">
          <!-- 选择同链接商品 -->
          <el-checkbox v-model="checked2" @change="allSame('goods_url', 'checked2')">{{
            $t('message.selectProductsWithTheSameLink') }}</el-checkbox>
        </div>
      </div>
      <!-- 批量还原 -->
      <el-button type="primary" class="primary" @click="reduction('', 'all')">{{ $t('message.batchRestore')
      }}</el-button>
    </div>
    <!-- 列表 -->
    <div class="table">
      <ol>
        <li class="flex03">
          <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
        </li>
        <!--客户信息  -->
        <li>{{ $t('message.userInfo') }}</li>
        <!--工厂  -->
        <li class="flex2">{{ $t('message.factory') }}</li>
        <!--商品链接  -->
        <li class="flex2">{{ $t('message.ProductLink') }}</li>
        <!--商品图片  -->
        <li>{{ $t('message.productPicture') }}</li>
        <!--SKU  -->
        <li>SKU</li>
        <!--状态  -->
        <li>{{ $t('message.status') }}</li>
        <!--操作  -->
        <li class="flex03">{{ $t('message.operation') }}</li>
      </ol>
      <ul v-for="(item, index) in tableData" :key="index">
        <li class="flex03">
          <el-checkbox v-model="item.checked" @change="isAll"></el-checkbox>
        </li>
        <!--客户信息  -->
        <li>
          <div>
            <p>{{ item.user.realname }}</p>
            <p>ID:{{ item.user.id }}</p>
          </div>
        </li>
        <!--工厂  -->
        <li class="flex2">{{ item.item_sku.item.shop_name }}</li>
        <!--商品链接  -->
        <li class="flex2">
          <a :href="item.goods_url.goods_url" rel="noopener noreferrer"
            style="color: #295FCF; text-decoration: underline;" target="_blank">
            {{ item.goods_url.goods_url }}
          </a>
        </li>
        <!--商品图片  -->
        <li>
          <el-image style="width: 70px;height: 70px;border-radius: 6px;" :src="item.pic" :preview-src-list="[item.pic]">
          </el-image>
        </li>
        <!--SKU  -->
        <li>
          <div>
            <p v-for="(detail, indexs) in item.item_sku.detail" :key="indexs">{{ detail.key }}:{{ detail.value }}</p>
          </div>
        </li>
        <!--状态  -->
        <li>
          {{ item.item_sku.is_on_sale >= 1 ? '有库存' : '已下架' }}
        </li>
        <!--操作  -->
        <li class="flex03">
          <!-- 还原 -->
          <el-button type="text" @click="reduction(item, 'single')">{{ $t('message.reduction') }}</el-button>
        </li>

      </ul>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 30, 40]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: false,
      checked1: false,
      checked2: false,
      datas: {
        user_id: localStorage.getItem('product_user_id') ? localStorage.getItem('product_user_id') : '',
        shop_id: '',
        shop_name: '',
        goods_id: '',
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0
    };
  },
  created() {
    this.productTmpHideList()
  },
  methods: {
    search() {
      this.datas.page = 1
      this.productTmpHideList()
    },
    reset() {
      this.datas = {
        user_id: '',
        shop_id: '',
        shop_name: '',
        goods_id: '',
        page: 1,
        pageSize: 10,
      }
      this.productTmpHideList()
    },
    // 同样全选
    allSame(type, checked) {
      if (!this[checked]) return false
      var list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      this.tableData.forEach(item => {
        list.forEach(items => {
          if (type == 'shop_name') {
            if (items.item_sku.item.shop_name == item.item_sku.item.shop_name) {
              item.checked = true
            }
          } else if (type == 'goods_url') {
            if (items.goods_url.goods_url == item.goods_url.goods_url) {
              item.checked = true
            }
          }
        })
      })
      this.isAll()
    },
    // 全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
    },
    // 检查是否全选
    isAll() {
      this.checked = this.tableData.every(item => item.checked)
    },
    reset() {
      this.datas = {
        user_id: '',
        shop_id: '',
        shop_name: '',
        goods_id: '',
        page: 1,
        pageSize: 10,
      }
      this.setDefaultValue()
      this.productTmpHideList()
    },
    // 无需维护列表
    productTmpHideList() {
      this.$api.productManagementApi.productTmpHideList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    //更新页数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.productTmpHideList();
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.productTmpHideList();
    },
    // 还原
    reduction(data, type) {
      let datas = {
        ids: [],
        user_id: ''
      }
      if (type == 'single') {
        datas = {
          user_id: data.user_id,
          ids: [data.id],
        }
      } else if (type == 'all') {
        this.tableData.forEach(item => {
          if (item.checked) {
            datas.ids.push(item.id)
          }
        })

      }
      if (datas.ids == false) return this.$message.error('未选择列表数据')


      this.$confirm('还原后，商品将进入绑定管理番号列表，继续对商品信息进行跟进，维护。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.productManagementApi.tmpShow(datas).then(res => {
          this.$message.success(res.msg)
          this.productTmpHideList()
        })
      }).catch(() => {

      });

    },
    //设置默认值
    setDefaultValue() {
      localStorage.setItem('product_user_id', this.datas.user_id)

    },
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(1.5) !important;
}

.search {
  display: flex;

  .item {
    width: 300px;
    margin-right: 24px;
  }
}

.operation {
  margin: 16px 0;
  display: flex;

  .check {
    padding: 12px;
    background: #EDEFF4;
    border-radius: 4px;
    margin-right: 24px;
    display: flex;
  }
}

.table {

  ol {
    height: 56px;
    background: #EDEFF4;
    border-radius: 4px;
  }

  ul {
    background-color: #fff;
    height: 100px;
    padding: 0;
  }

  li {
    justify-content: left !important;
  }

  .flex03 {
    justify-content: center !important;
    flex: 0.3;
  }

  .flex2 {
    flex: 2;
  }
}
</style>